<template lang="pug">
    .col-md-3
        .contact-sidebar-title  {{lenguageSelected.content9}}
        .contact-sidebar-content
            .contact-sidebar-box(v-for="location in lenguageSelected.locationsList" :key="JSON.stringify(location)")
                div(v-for="detail in location" :key="JSON.stringify(detail)" :class="detail.type=='title'? 'contact-sidebar-box-title' : 'contact-sidebar-box-desc'")
                    |   {{ detail.content }}
</template>

<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang;
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown ? this.$refs.description.offsetTop - 60 : 0

        window.scroll({
            top: to,
            left: 0,
            behavior: 'smooth'
        })

        this.moveToDown = !this.moveToDown
    },

    data: function(){
        return{
            lenguage: 'ES',
            lenguageEN: {
                content9: 'Corporate Headquarters:',
                locationsList: [
                    [
                        { type: 'title', content: 'ATP Tower Holdings, LLC' },
                        { type: 'desc', content: '4000 Hollywood Blvd., Suite 425S' },
                        { type: 'desc', content: 'Hollywood, Florida 33021 - USA' },
                        { type: 'desc', content: '+1 (954) 315-5370' }
                    ],
                    [
                        { type: 'title', content: 'Andean Tower Partners Colombia SAS' },
                        { type: 'title', content: 'ATP Fiber Colombia SAS' },
                        { type: 'desc', content: 'Carrera 19b # 166-50' },
                        { type: 'desc', content: 'Bogotá, D.C. - República de Colombia' },
                        { type: 'desc', content: '+57 (1) 7452846' }
                    ],
                    [
                        { type: 'title', content: 'Andean Telecom Partners Chile SpA' },
                        { type: 'title', content: 'ATP Fiber Chile SpA' },
                        { type: 'desc', content: 'Av. Apoquindo No. 2827, Oficina 702' },
                        { type: 'desc', content: 'Las Condes, Santiago - Chile' },
                        { type: 'desc', content: '+56 (2) 2303-7800' }
                    ],
                    [
                        { type: 'title', content: 'Andean Telecom Partners Perú S.R.L.' },
                        { type: 'title', content: 'Redes de Fibra del Perú S.R.L.' },
                        { type: 'desc', content: 'Víctor Andrés Belaunde No. 147,' },
                        { type: 'desc', content: 'Oficina 701 Vía Principal No. 103' },
                        { type: 'desc', content: 'Edificio Real Diez, San Isidro, Lima 27 - Perú' },
                        { type: 'desc', content: '+51 (1) 611-8484' }
                    ],
                    [
                        { type: 'title', content: 'Andean Tower Partners, S.L.U.' },
                        { type: 'desc', content: 'Calle de Zurbarán, 10, 1st Floor' },
                        { type: 'desc', content: 'Madrid, Spain' },
                        { type: 'desc', content: '28010' },
                        { type: 'desc', content: '+34 679 680 829' },
                    ],
                    [
                        { type: 'title', content: 'Torrec III GmbH' },
                        { type: 'desc', content: 'Zählerweg 6' },
                        { type: 'desc', content: '6300 Zug' },
                        { type: 'desc', content: 'Switzerland' },
                        { type: 'desc', content: '+41 792592215' }
                    ],
                    [
                        { type: 'title', content: 'BTS-Towers-Ecuador C.L.' },
                        { type: 'desc', content: 'Sitios-BTS C.L.' },
                        { type: 'desc', content: 'Francisco de Orellana  E9-195 y Av. 6 de Diciembre Edificio Alisal de Orellana - Oficina 903' },
                        { type: 'desc', content: 'Quito - Ecuador' },
                        { type: 'desc', content: 'Tel: +593 2510-8533' }
                    ],
                ]
            },
            lenguageES: {
                content9: 'Sedes corporativas:',
                locationsList: [
                    [
                        { type: 'title', content: 'ATP Tower Holdings, LLC' },
                        { type: 'desc', content: '4000 Hollywood Blvd., Suite 425S' },
                        { type: 'desc', content: 'Hollywood, Florida 33021 - USA' },
                        { type: 'desc', content: '+1 (954) 315-5370' }
                    ],
                    [
                        { type: 'title', content: 'Andean Tower Partners Colombia SAS' },
                        { type: 'title', content: 'ATP Fiber Colombia SAS' },
                        { type: 'desc', content: 'Carrera 19b # 166-50' },
                        { type: 'desc', content: 'Bogotá, D.C. - República de Colombia' },
                        { type: 'desc', content: '+57 (1) 7452846' }
                    ],
                    [
                        { type: 'title', content: 'Andean Telecom Partners Chile SpA' },
                        { type: 'title', content: 'ATP Fiber Chile SpA' },
                        { type: 'desc', content: 'Av. Apoquindo No. 2827, Oficina 702' },
                        { type: 'desc', content: 'Las Condes, Santiago - Chile' },
                        { type: 'desc', content: '+56 (2) 2303-7800' }
                    ],
                    [
                        { type: 'title', content: 'Andean Telecom Partners Perú S.R.L.' },
                        { type: 'title', content: 'Redes de Fibra del Perú S.R.L.' },
                        { type: 'desc', content: 'Víctor Andrés Belaunde No. 147,' },
                        { type: 'desc', content: 'Oficina 701 Vía Principal No. 103' },
                        { type: 'desc', content: 'Edificio Real Diez, San Isidro, Lima 27 - Perú' },
                        { type: 'desc', content: '+51 (1) 611-8484' }
                    ],
                    [
                        { type: 'title', content: 'Andean Tower Partners, S.L.U.' },
                        { type: 'desc', content: 'Calle de Zurbarán, 10, 1ra Planta' },
                        { type: 'desc', content: 'Madrid, España' },
                        { type: 'desc', content: '28010' }
                    ],
                    [
                        { type: 'title', content: 'Torrec III GmbH' },
                        { type: 'desc', content: 'Zählerweg 6' },
                        { type: 'desc', content: '6300 Zug' },
                        { type: 'desc', content: 'Suiza' },
                        { type: 'desc', content: '+41 792592215' }
                    ],
                    [
                        { type: 'title', content: 'BTS-Towers-Ecuador C.L.' },
                        { type: 'desc', content: 'Sitios-BTS C.L.' },
                        { type: 'desc', content: 'Francisco de Orellana  E9-195 y Av. 6 de Diciembre Edificio Alisal de Orellana - Oficina 903' },
                        { type: 'desc', content: 'Quito - Ecuador' },
                        { type: 'desc', content: 'Tel: +593 2510-8533' }
                    ],
                    
                ]
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>

<style lang="scss" scoped>
    .error{
        color: red;
        font-size: 11px;
    }
</style>




// WEBPACK FOOTER //
// src/components/molecules/PmContactTable.vue